import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';
import { route } from 'preact-router';
import classnames from 'classnames';

function goHome () {
	route('/');
}

const SYSTEM_TRIGGER_DELAY = 3000;

export default class Header extends Component {
	lastTouchStart () {
		return this.touch && performance.now() - this.touch;
	}

	render ({ kiosk, section }) {
		return (
			<header class={ style.header }>
				<nav>
					{ section !== 'home' && <Link class={ style.restart } onClick={ goHome } href="/">Restart</Link>}

					{ section !== 'system' &&
					<a
						class={ classnames(style.logo, style[`logo_${section}`]) }
						target="_blank"
						href="http://www.airproducts.co.uk"
						onClick={event => {
							if (kiosk && (!this.touch || this.lastTouchStart() > SYSTEM_TRIGGER_DELAY)) {
								event.preventDefault();
							}
						} }
						onTouchStart={ () => {
							if (section === 'home') {
								this.touch = performance.now();
							}
						} }
						onTouchEnd={ () => {
							if (section === 'home' && this.lastTouchStart() > 3000) {
								route('/system');
							}

							this.touch = null;
						} }>Air Products</a>
					}
				</nav>
			</header>
		);
	}
}



// WEBPACK FOOTER //
// ./components/header/index.js